// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinFilledSvg from "@ant-design/icons-svg/es/asn/PushpinFilled";
import AntdIcon from '../components/AntdIcon';

var PushpinFilled = function PushpinFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinFilledSvg
  }));
};

PushpinFilled.displayName = 'PushpinFilled';
export default React.forwardRef(PushpinFilled);